import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { openingHours } from '../data/mockData';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-grid">
          {/* Contact Information */}
          <div className="contact-info">
            <h2 className="section-title">Visit Us</h2>
            
            <div className="contact-item">
              <div className="contact-icon">
                <MapPin className="w-6 h-6" />
              </div>
              <div>
                <h3 className="contact-label">Address</h3>
                <p className="contact-text">29 Chapel Market</p>
                <p className="contact-text">London N1 9EN</p>
                <p className="contact-text">United Kingdom</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <Phone className="w-6 h-6" />
              </div>
              <div>
                <h3 className="contact-label">Phone</h3>
                <a href="tel:+442079163212" className="contact-link">
                  020 7837 2833
                </a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <Clock className="w-6 h-6" />
              </div>
              <div>
                <h3 className="contact-label">Opening Hours</h3>
                <div className="hours-list">
                  <div className="hours-row">
                    <span className="hours-day">Monday</span>
                    <span className="hours-time">Closed</span>
                  </div>
                  <div className="hours-row">
                    <span className="hours-day">Tuesday – Friday</span>
                    <span className="hours-time">12:00 PM – 3:00 PM<br/>5:30 PM – 10:00 PM</span>
                  </div>
                  <div className="hours-row">
                    <span className="hours-day">Saturday</span>
                    <span className="hours-time">12:00 PM – 10:00 PM</span>
                  </div>
                  <div className="hours-row">
                    <span className="hours-day">Sunday</span>
                    <span className="hours-time">12:00 PM – 9:00 PM</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div className="map-wrapper">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.6448918367756!2d-0.10576892346198838!3d51.53655700963077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b5e8c8c8c8d%3A0x1e1e1e1e1e1e1e1e!2s29%20Chapel%20Market%2C%20London%20N1%209EN%2C%20UK!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Masigo Location"
              className="google-map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
